import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CommonHeading from "../../../common/components/Custom Hooks/CommonHeading";
import {
  getDepartment,
  getMarkFavorite,
  getPatient,
  getPatientVisitLisit,
  getPrescription,
  getPrescriptionPrint,
  getTemplateMultipleData,
  templateSearch,
} from "../services/EMRServices/emrServices";
import PatientInfo from "./PatientInfo";

import { Tooltip } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import CheckBoxField from "../../../common/components/FormFields/CheckBoxField";
import BloodGroup from "./GynacBloodGroup";
import GynacExaminations from "./GynacExaminations";
import GynacHOPI from "./GynacHOPI";
import GynacObstetricDetails from "./GynacObstetricDetails";
import GynacPastHistory from "./GynacPastHistory";
import GyncMenstrualHistory from "./GyncMenstrualHistory";

import { format } from "date-fns";
import CommonBackDrop from "../../../common/components//CommonBackDrop/CommonBackDrop";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../common/components/Toasts/CustomToasts";
import { getDoctors } from "../services/EMRServices/emrServices";
// import {
//   getPathologyHistory,
//   getRadiologyHistory,
// } from "../../../IPD/services/discharge/dischargeServices";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
// import { saveGynacEMR } from "../../services/GynacEmr/GynacEmr";
// import { getOncologyPreviousVisitsData } from "../../services/oncologyEmr/OncologyEmrServices";
// import { getVisitPatientList } from "../../services/RegistrationServices/PatientRegistrationServices/patientRegistrationServices";
import OPDAdvice from "../common/Advice";
import OPDDocuments from "../common/Documents";
import OPDMedicalHistory from "../common/MedicalHistory";
import OPDMedication from "../common/Medication";
import OPDPathology from "../common/Pathology";
import PathologyReportModal from "../common/PathologyReportModal";
import PatientHistoryModalNewAll from "../common/PatientHistoryModalNew";
import OPDRadiology from "../common/Radiology";
import OPDRef from "../common/Ref";
import OPDServices from "../common/Services";
import OPDSurgery from "../common/Surgery";
import Vital from "../common/Vital";
import GynacVitalChart from "../common/VitalChart";
import NextFollowUp from "../common/NextFollowUp";
// import PrescriptionDental from "../commonNew/PrescriptionDental";
import {
  AddMedicationIcon,
  ForceFullIcon,
  GrowthIcon,
  HistorySheet,
  PartnerInfo,
  PathologyIcon,
  PergentIcon,
  RadiologyIcon,
  VitalChart,
} from "../common/EmrCommonAsset/Asset";
import ANCModal from "./ANCModal";
import ANCPatientInfo from "./ANCPatientInfo";
import { EMRProvider, useEMRContext } from "./EMRContextGync";
import InvestigationRequest from "./RequestInvestigations.jpg";
import { CloseModalIcon } from "../../../common/components/assets/commonassets/CommonAssets";
import { useGetUserActions } from "../../../common/components/Custom Hooks/useGetUserActions";
import Allergies from "../common/Allergies";
import Complaints from "../common/Complaints";
import OPDDiagnosis from "../common/Diagnosis";
import Habit from "../common/Habit";
import Instruction from "../common/Instruction";
import PlanofCare from "../common/PlanofCare";
import AdviceAdmissionModal from "./AdviceAdmissionModal";
import ANCView from "./ANCView";
import ANCWorkSheet from "./ANCWorkSheet";
import Customs from "./Customs";
import ReqInvestigationFormModal from "./ReqInvestigationFormModal";
import HighRiskFactors from "./HighRiskFactors";

const GynacEmr = (props) => {
  const defaultValues = {
    temp: "",
    pulseRate: "",
    bpSystolic: "",
    bpDiastolic: "",
    spO2: "",
    weight: "",
    urineAlbumin: "",
    bsl: "",
    height: "",
    bmi: "",
    respiration: "",
    bloodSugar: "",
    bloodGroup: "",
    allergyType: null,
    allergyDescription: "",
    complaint: "",
    duration: "",
    since: "",
    DM: "",
    HTN: "",
    heartDisease: "",
    surgicalHistory: "",
    familyHistory: "",
    otherHistory: "",
    hopi: "",
    hopiAnc: "",
    highRisk: "",
    highRiskAnc: "",
    menstrualHistory: "",
    Anclmp: new Date(),
    conception: "",
    cycleLength: "",
    ancedd: new Date(),
    gravida: "",
    para: "",
    living: "",
    abortion: "",
    gravida1: "",
    gravida2: "",
    gravida3: "",
    eddbyNT: "",
    modeOfDelivery: null,
    age: "",
    otherInfo: "",
    otherHistory: "",
    yes: false,
    no: false,
    lastChildBirth: "",
    rs: "",
    cvs: "",
    pa: "",
    fs: "",
    localExamination: "",
    ps: "",
    pv: "",
    leftSideBreastExmination: "",
    rightSideBreastExmination: "",
    nextFollowupDate: null,
    lmp: null,
    conception: null,
    edd: null,
    anc: false,
    searchDrugMedicine: "",
    frequency: "",
    instructions: "",
    medicDuration: "",
    MedidurationIn: "",
    noteFollowup: "",
    menstrualHistory: "",
    pnc: false,
    eddbyU1: null,
    eddbyNT: "",
    frequency: null,
    instructions: null,
    medicDuration: "",
    MedidurationIn: "",
    route: null,
    quantity: "",
    ivFlowRate: "",
    note: "",
    conception: new Date(),
    type: "Brand",
    Anclmp: null,
    startDate: new Date(),
    pastOtherHistory: " ",
    bsa: "",
    partnerMobileNo: "",
    patientAadharNo: "",
    partnerAadharNo: "",
    lmp: null,
    isPregnant: false,
    date: new Date(),
    gestureAge: "",
    fetalPosition: "",
    fetalHeart: "",
    liquor: "",
    placenta: "",
    doppler: "",
    modeOfdelivery: [],
    eddByGaString: "",
    gaByUsgString: "",
    menstrualRegular: false,
    menstrualDuration: "",
    menstrualLength: "",
    isHeavy: false,
    isNormal: false,
    painLess: false,
    painFull: false,
    gaByDate: "",
  };

  const methods = useForm({
    defaultValues: defaultValues,
    // resolver: yupResolver(schema),
    mode: "onChange",
  });

  let treatmentCompetedTypes = methods.watch("treatmentCompetedTypes");

  return (
    <EMRProvider>
      <GynacEmrContent
        methods={methods}
        patientInfo={props?.patientInfo}
        close={props?.close}
        // tabIndex={tabIndex}
        // setTabIndex={setTabIndex}
      />
    </EMRProvider>
  );
};

const GynacEmrContent = ({ methods, patientInfo, close }) => {
  //Patient Details useState
  const {
    patientDetails,
    setPatientDetails,
    setVisitDetails,
    role,
    setRole,
    complaintsData,
    setComplaintsData,
    allergiesData,
    setAllergiesData,
    diagnosisData,
    setDiagnosisData,
    surgeryData,
    setSurgeryData,
    pathologyData,
    setPathologyData,
    radiologyData,
    setRadiologyData,
    adviceData,
    setAdviceData,
    serviceData,
    setServiceData,
    medicationData,
    setMedicationData,
    pathology,
    setPathology,
    vital,
    setVital,
    BloodGroupData,
    finalData,
    setFinalData,
    openPost,
    setOpenPost,
    divData,
    setDivData,
    departmentOption,
    setDepartmentOption,
    doctorOption,
    setDoctorOption,
    instractionDataResult,
    setInstractionDataResult,
    fields,
    setFields,
    editData,
    setEditData,
    departmentCOption,
    setDepartmentCOption,
    doctorCoption,
    setdoctorCoption,
    AncAllergiesData,
    setAncAllergiesData,
    AncComplaintsData,
    setAncComplaintsData,
    dataAllergies,
    setDataAllergies,
    dataComplaints,
    setDataComplains,
    dataDiagnosis,
    setDataDiagnosis,
    dataSurgery,
    setDataSurgery,
    dataPathology,
    setDataPathology,
    dataRadiology,
    setDataRadiology,
    dataServices,
    setDataServices,
    openMedicationModal,
    setOpenMedicationModal,
    openViewVitals,
    setOpenViewVital,
    openPatientHistory,
    setPatientHistory,
    doctomentData,
    setDocumentData,
    dataDocument,
    setDataDocument,
    openPartnerModal,
    setOpenPartnerModal,
    ancChecked,
    setAncChecked,
    isAncClose,
    setIsAncClose,
    dataMedication,
    setDataMedication,
    dataInstruction,
    setDataInstruction,
    selectedFile,
    setSelectedFile,
    base64Image,
    setBase64Image,
    rowImage,
    setRowImage,
    image,
    setImage,
    open,
    setOpen,
    vistitList,
    setVisitList,
    parentId,
    setParentId,
    isancFlag,
    setIsAncFlag,
    patientHistoryData,
    setPatientHistoryData,
    isDirty,
    setIsDirty,
    newDoc,
    setNewDoc,
    actions,
    setActions,
    dataRef,
    setDataRef,
    openFavorite,
    setOpenFavorite,
    markFavoriteData,
    setMarkFavoriteData,
    templateOption,
    setTemplateOption,
    isDraft,
    setIsDraft,
    documentTypeList,
    setDocumentTypeList,
    instraction,
    setInstraction,
    weight,
    setWeight,
    height,
    setHeight,
    usgSonographyDetails,
    setUsgSonographyDetails,
  } = useEMRContext();

  const [saveData, setSaveData] = useState(false);
  const [edit, setEdit] = useState(false);
  const [openPrint, setOpenPrint] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openConfimationModal, setOpenConfirmationModal] = useState(false);
  const [pathHistoryData, setPathHistoryData] = useState([]);
  const [radioHistoryData, setRadioHistoryData] = useState([]);
  const [LIMSType, setLIMSType] = useState("Pathology");
  const [openInvestigationModal, setOpenInvestigationModal] = useState(false);
  const [templateDataDetail, setTemplateDataDetails] = useState(null);
  const [patientVisitData, setPatientVisitData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [pastData, setPastData] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isAnc, setIsAnc] = useState(false);
  const [openWorkSheet, setOpenANCWorkSheet] = useState(false);
  const [openGrowthChart, setOpenGrowthChart] = useState(false);
  const [openANcView, setOpenANCView] = useState(false);
  const [openAdmissionAdvice, setOpenAdmissionAdvice] = React.useState(false);
  const [adviceDetails, setAdviceDetails] = React.useState(null);
  const [patientData, setPatientData] = React.useState(null);
  const [investigationRequest, setInvestigationRequest] = React.useState(false);
  const [openRequestModal, setOpenRequestModal] = React.useState(false);
  const [isNoFollowup, setIsNoFollowup] = React.useState(false);
  const [selectedChipsCount, setSelectedChipsCount] = React.useState(0);

  const handleCloseRequestModal = () => {
    if (openRequestModal === true) {
      setOpenRequestModal(false);
    }
  };

  React.useEffect(() => {
    console.log("The data in the patient EMR is :", location?.state);
    if (location?.state !== null && location?.state !== undefined) {
      if (location?.pathname === "/nursing/clinicalcarechart") {
        setPatientData(patientInfo);
      } else {
        setPatientData(location?.state);
      }
    }
  }, []);

  const handleCloseAdmissionAdvice = () => {
    if (openAdmissionAdvice === true) {
      setOpenAdmissionAdvice(false);
    }
  };

  const handleAdmissionField = () => {
    if (fields?.length > 0) {
      let dataArray = [...fields];
      for (let field of fields) {
        if (field?.name === "admission") {
          field.checked = false;
        }
      }
      setFields(dataArray);
    }
  };

  const isGync = true;

  const handleClose = () => {
    setOpenConfirmationModal(false);
  };

  const navigate = useNavigate();

  const location = useLocation();
  console.log("The location in the Gynac EMR is :", location, patientInfo);

  const defaultValues = {};
  let ancWatch = methods.watch("anc");
  let userRole = JSON.parse(localStorage.getItem("userInfo"));
  let patientName,
    patientId,
    visitId,
    visitNumber,
    visitDate,
    status,
    patientVisitedDepartment,
    patientVisitedDepartmentId,
    paramsData,
    age,
    uhid,
    doctor,
    doctorId,
    ageInYears,
    visitIdForSurgery;

  if (location?.state !== null && location?.state !== undefined) {
    patientName = location?.state?.patientName;
    patientId = location?.state?.patientId || patientData?.patientId;
    visitNumber = location?.state.visitNumber;
    visitDate = location?.state.visitDate;
    visitId = location?.state.visitId || patientData?.patientVisitId;
    status = location?.state?.status || "";
    patientVisitedDepartment =
      location?.state.department || patientData?.department;
    patientVisitedDepartmentId =
      location?.state.departmentId || patientData?.departmentId;

    age = location?.state?.age;
    uhid = location?.state?.uhid;
    doctor = location?.state?.doctor;
    doctorId = location?.state?.doctorId;
    ageInYears = location?.state?.ageInYears;
    visitIdForSurgery = location?.state.visitIdForSurgery;
  }

  React.useEffect(() => {
    if (fields?.length > 0) {
      let filtered = fields.filter((f) => f.name === "admission");

      if (filtered?.[0]?.checked === true) {
        setOpenAdmissionAdvice(true);
      } else {
        setOpenAdmissionAdvice(false);
      }
    }
  }, [fields]);

  let obj = {
    page: 0,
    size: 10,
    searchString: "",
    menuId: patientData?.visitListMenuId,
    departmentId: null,
    unitId: userRole?.unitId,
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),
  };
  useEffect(() => {
    // getVisitPatientList(obj).then((response) => {
    //   setActions(response.data.actions);
    // });
  }, []);

  useEffect(() => {
    let userRole = JSON.parse(localStorage.getItem("loggedUser"));
    if (patientData !== null) {
      if (
        userRole?.isDoctor &&
        patientData?.status?.toLowerCase() === "confirmed"
      ) {
        warningAlert("Call not Started");
      }
    }
  }, []);

  const handlePatientDataAndVisitList = () => {
    if (patientData?.patientId !== undefined) {
      getPatient(
        patientData?.patientId,
        patientData?.visitId || patientData?.patientVisitId,
        patientData?.visitNumber,
      )
        .then((response) => {
          setPatientDetails(response.data.result.patientInfo);
          setVisitDetails(response.data.result.visits);
        })
        .catch((res) => res);
    }
  };

  const [actionsData, setActionsData] = useState([]);

  useEffect(() => {
    // useGetUserActions(10)
    //   .then((response) => {
    //     setActionsData(response);
    //   })
  }, []);
  useEffect(() => {
    getDepartment(userRole.unitId)
      .then((response) => {
        setDepartmentOption(response.data.result);
      })
      .catch((err) => err);
  }, []);

  let department = methods.watch("department");

  useEffect(() => {
    if (department?.id > 0) {
      getDoctors(department?.id, userRole.unitId).then((response) => {
        setDoctorOption(response.data.result);
      });
    }
  }, [department, userRole.unitId]);

  useEffect(() => {
    let filteredAction = actionsData?.filter(
      (a) => a?.permission?.toLowerCase() === "request investigations",
    );

    if (filteredAction?.length > 0) {
      setInvestigationRequest(true);
    } else {
      setInvestigationRequest(false);
    }
  }, [actionsData]);

  useEffect(() => {
    let userRole = JSON.parse(localStorage.getItem("loggedUser"));
    userRole?.role?.toLowerCase() === "doctor"
      ? setRole("Doctor")
      : userRole?.role?.toLowerCase() === "nurse"
        ? setRole("Nurse")
        : setRole("");
  }, [role]);

  useEffect(() => {
    handlePatientDataAndVisitList();
    // handlePreviousVisitDetails();
  }, [patientData]);

  useEffect(() => {
    if (patientData !== null) {
      let obj = {
        department: patientData?.department,
        patientInfoId: patientData?.patientId,
        visitIdList: [patientData?.visitId],
        visitNumber: [patientData?.visitNumber],
        doctorId: patientData?.doctorId,
      };
      // getOncologyPreviousVisitsData(obj).then((response) => {
      //   setEditData(response.data.result);
      //   if (response.data.map) {
      //     if (response.data.map.pastVisits) {
      //       let result = JSON.parse(response.data.map.pastVisits);
      //       setVisitList(result);
      //     }
      //     setParentId(response.data.map.parentVisitId);
      //     setIsAnc(response.data.map.isanc);
      //   }
      // });
    }
  }, [patientData]);

  useEffect(() => {
    methods.setValue("anc", isAnc);
  }, [isAnc]);
  const allergiesDetailslist = allergiesData.reduce((accumulator, data) => {
    if (data?.allergyType !== null) {
      accumulator.push({
        allergyType: data.allergy,
        allergyDescription: data.description,
      });
    }
    return accumulator;
  }, []);

  const presentingComplaintsDataResultTemp = complaintsData.reduce(
    (accumulator, data) => {
      accumulator.push({
        complaint: data?.complaint,
        since: Number(data.since),
        duration: data.duration,
        isNew: true,
      });

      return accumulator;
    },
    [],
  );
  const diagnosisOfIndexCancerDataResultTemp = diagnosisData.reduce(
    (accumulator, data) => {
      accumulator.push({
        icd: data.diagnosis,
        duration: data.duration,
        since: Number(data.since),
        isChronic: data?.chronic,
        status: data?.status || "",
      });

      return accumulator;
    },
    [],
  );
  const pathologyDataResult = pathologyData.reduce((accumulator, data) => {
    accumulator.push({
      id: data?.id,
      testType: "Pathology",
      testTypeId: 1,
      investigation: data.service,
      investigationImageName: null,
      investigationPathBase64: null,
      testId: data.testId,
      serviceId: data.serviceId,
      serviceName: data.investigation,
      isUrgent: true,
      isNew: true,
      deleteFlag: data?.isDeleteFlag,
    });
    // }
    return accumulator;
  }, []);

  const radiologyDataResult = radiologyData.reduce((accumulator, data) => {
    accumulator.push({
      testType: "Radiology",
      testTypeId: 2,
      investigation: data.service,
      investigationImageName: null,
      investigationPathBase64: null,
      testId: data.testId,
      serviceId: data.serviceId,
      serviceName: data.investigation,
      isUrgent: data.urgent,
      isNew: true,
      id: data?.id,
      deleteFlag: data?.isDeleteFlag,
    });
    // }
    return accumulator;
  }, []);
  const servicesDataResult = serviceData.reduce((accumulator, data) => {
    accumulator.push({
      id: data?.id !== "" ? data?.id : null,
      serviceId: data.serviceId || data.serviceId,
      serviceName: data.service || data.investigation,
      quantity: data.quantity || 1,
      isNew: true,
      deleteFlag: data?.isDeleteFlag,
    });
    // }
    return accumulator;
  }, []);
  const surgeryDataResult = surgeryData.reduce((accumulator, data) => {
    if (data.surgeryId !== "" && data.surgeonId !== "") {
      accumulator.push({
        surgeryDetails: [
          {
            id: data.surgeryId,
          },
        ],
        surgeon: [
          {
            id: data.surgeonId,
          },
        ],
      });
    }
    return accumulator;
  }, []);

  const mergeArray = (arr) => {
    return arr.reduce((acc, val) => {
      const ind = acc.findIndex((item) => item.instruction === val.instruction);
      if (ind !== -1) {
      } else {
        acc.push(val);
      }
      return acc;
    }, []);
  };

  let instructionWatch = methods.watch("instruction");
  const generalInstraction = mergeArray(instractionDataResult).map(
    (row) => row?.instruction,
  );

  let medicationDataResult = [];
  for (let obj of medicationData) {
    if (obj.drugName !== "") {
      medicationDataResult.push({
        code: obj?.code,
        dosage: obj.dosage,
        drugName: obj.drugName,
        drugType: obj.drugType,
        duration: obj.duration,
        durationIn: obj.durationIn,
        frequency: obj.frequency,
        genericDescription:
          obj.genericdescription !== undefined ? obj.genericdescription : null,
        id: obj.id !== null ? obj.id : null,
        instruction: obj.instruction,
        isNew: true,
        ivFlowRate: Number(obj.ivFlowRate),
        notes: obj.note,
        quantity: Number(obj.quantity),
        route: obj.route,
        startDate: obj.startDate,
        drugId: obj.drugId,
        drugTapering: obj.drugTapering,
        isParent: obj.isParent,
      });
    }
  }

  const gravidaDataResult = (gravidaData) => {
    let resultGravida = [];
    if (divData?.length > 0) {
      for (let dataObject of divData) {
        let gravidaObjet = {
          deliveryMode: dataObject?.modeOfDelivery,
          age: Number(dataObject?.age),
          gender: dataObject?.gender,
          otherInfo: dataObject?.otherInfo,
        };
        resultGravida?.push(gravidaObjet);
      }

      return resultGravida;
    } else {
      return [];
    }
  };

  function calculateGADays(lmpDate) {
    const today = new Date();

    const diffMs = today - lmpDate;

    // Convert to days
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    return diffDays;
  }

  function formatWeeksDays(totalDays) {
    const weeks = Math.floor(totalDays / 7);
    const days = totalDays % 7;

    if (days === 0) {
      return `${weeks} Weeks`;
    } else {
      return `${weeks} Weeks , ${days} Days`;
    }
  }

  const checkedNames = fields
    .filter((field) => field.checked)
    .map((field) => field.name);

  let lmp = methods.watch("lmp");
  let edd = methods.watch("edd");
  let eddbyU1Watch = methods.watch("eddbyU1");

  let surgicalHistory = methods.watch("surgicalHistory");
  let familyHistory = methods.watch("familyHistory");
  let cvs = methods.watch("cvs");
  let pa = methods.watch("pa");
  let ps = methods.watch("ps");
  let rs = methods.watch("rs");

  useEffect(() => {
    let lmpObstrical;
    if (lmp !== null) {
      lmpObstrical = new Date(lmp);
    }
    methods.setValue("lmp", lmpObstrical);

    methods.setValue("familyHistory", familyHistory);
    methods.setValue("surgicalHistory", surgicalHistory);
    methods.setValue("cvs", cvs);

    methods.setValue("pa", pa);
    methods.setValue("ps", ps);

    methods.setValue("rs", rs);
  }, [ancChecked]);

  useEffect(() => {
    if (
      lmp !== null &&
      edd !== null &&
      lmp !== undefined &&
      edd !== undefined
    ) {
      let days = calculateGADays(new Date(lmp));

      methods.setValue("eddByGaString", formatWeeksDays(days));
    }
  }, [lmp, edd]);

  function getDateDifferenceInDays(date1, date2) {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    // Get difference in milliseconds
    const diffInMs = d2 - d1;

    // Convert to days (1 day = 24 * 60 * 60 * 1000 ms)
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    return diffInDays;
  }

  useEffect(() => {
    // Define & normalize today's date
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Define & normalize EDD
    const edd = new Date(eddbyU1Watch);
    edd.setHours(0, 0, 0, 0);

    // Difference in days (EDD - Today)
    const dateDifference = getDateDifferenceInDays(today, edd);

    if (dateDifference >= 0) {
      const actualDays = 280 - dateDifference;

      if (actualDays > 0) {
        methods.setValue("gaByUsgString", formatWeeksDays(actualDays));
      }
    }
  }, [eddbyU1Watch]);

  const documentsDataResult = doctomentData.reduce((accumulator, data) => {
    accumulator.push({
      documentName: data?.document,
      documentTypeId: data?.documentTypeId,
      documentType: data.documentType,
      filename: data?.filename,
      documentPathBase64: data?.documentPathBase64,
    });

    return accumulator;
  }, []);
  let datelmp = methods.watch("ancedd");
  let adviceDescription = methods.watch("adviceDescription");
  let complaint = methods.watch("complaint");
  let nextFollowupDate = methods.watch("nextFollowupDate");

  console.log("nextFollowupDatenextFollowupDatenextFollowupDate", isNoFollowup);

  let allergies = methods.watch("allergies");

  const onSubmit = (data) => {
    console.log(
      "The added keys for the gynac emr are :",
      data?.hopi,
      data?.hopiAnc,
      data?.highRisk,
      data?.highRiskAnc,
    );

    if (
      (data?.nextFollowupDate === null && isNoFollowup === false) ||
      (data?.nextFollowupDate === undefined && isNoFollowup === false)
    ) {
      warningAlert("Kindly Select Next Followup Date..!");
    } else {
      let instractionData = [];
      let sonographyDetails = [];

      if (usgSonographyDetails?.length > 0) {
        for (let infoObject of usgSonographyDetails) {
          let postSonographyObject = {
            usgDate: infoObject?.date,
            gestureAge: infoObject?.gestureAge,
            fetalPosition: infoObject?.fetalPosition,
            gaByDate: infoObject?.gaByDate,
            fetalHeart: infoObject?.fetalHeart,
            liquor: infoObject?.liquor,
            placenta: infoObject?.placenta,
            doppler: infoObject?.doppler,
          };
          sonographyDetails.push(postSonographyObject);
        }
      }

      let instractionObj = {
        instraction: data?.instruction,
      };

      if (
        instractionObj?.instraction !== undefined &&
        instractionObj?.instraction !== ""
      ) {
        instractionData.push(instractionObj);
      }
      let generalIns = instractionData.map((item) => item.instraction);

      let ComplaintsData = [];
      let complaintobj = {
        complaint: data.complaints !== undefined ? data.complaints : null,
        isNew: data.complaints !== undefined ? false : true,
      };
      if (
        complaintobj?.complaint !== undefined &&
        complaintobj?.complaint !== ""
      ) {
        ComplaintsData.push(complaintobj);
      }

      let allergiesData = [];
      let allergiesObj = {
        allergyType: data?.allergies,
        isNew: data.allergies !== undefined ? false : true,
      };
      if (
        allergiesObj?.allergyType !== undefined &&
        allergiesObj?.allergyType !== ""
      ) {
        allergiesData.push(allergiesObj);
      }
      let diagnosisData = [];
      let diagnosisObj = {
        icd: data.diagnosis,
      };
      if (diagnosisObj?.icd !== undefined && diagnosisObj?.icd !== "") {
        diagnosisData.push(diagnosisObj);
      }

      let refDep = {
        id: data.departmentConsultant?.id,
        departmentName: data.departmentConsultant?.label,
      };
      let refDoc = {
        id: data.doctorConsultant?.id,
        firstName: data.doctorConsultant?.label,
      };
      let partnerDetails = {
        aadharNo: data?.partnerAadharNo,
        ageDuringMarriage: Number(data?.partnerAgeDuringMarriage),
        currentAge: Number(data?.age),
        education: data?.partnerEducation,
        mobileNo: data?.partnerMobileNo,
        name: data?.name,
        occupation: data?.partnerOccupation,
      };
      let patientDetailsANC = {
        aadharNo: data?.patientAadharNo,
        ageDuringMarriage: Number(data.patientAgeDuringMarriage),
        currentAge: 0,
        education: data?.patientEducation,
        mobileNo: data?.patientMobileNo,
        name: "string",
        occupation: data?.patientOccupation,
      };
      let patientDetailsFill = Object.values(patientDetailsANC);
      let partnerDetailsFill = Object.values(partnerDetails);
      let tempSurgery = [];
      tempSurgery.push({
        patientVisit: { visitId },
        surgerySurgeonDetails:
          surgeryDataResult.length > 0 ? surgeryDataResult : null,
      });
      let FollowDate;
      if (nextFollowupDate !== null && nextFollowupDate !== undefined) {
        FollowDate = format(nextFollowupDate, "yyyy-MM-dd");
      }
      let datelmp;
      if (
        data?.lmp !== null &&
        data?.lmp !== undefined &&
        data?.lmp !== "Invalid Date"
      ) {
        datelmp = format(data.lmp, "yyyy-MM-dd");
      }
      let dateconception;
      if (
        data.conception !== null &&
        data.conception !== undefined &&
        data.conception !== "Invalid Date"
      ) {
        dateconception = format(data.conception, "yyyy-MM-dd");
      }
      let dateedd;
      if (
        data.edd !== null &&
        data.edd !== undefined &&
        data.edd !== "Invalid Date"
      ) {
        dateedd = format(data.edd, "yyyy-MM-dd");
      }
      // let edd;
      let eddbyU1;
      let eddBynt;
      // let lmp;
      if (
        data.ancedd !== null &&
        data.ancedd !== undefined &&
        data.ancedd !== "Invalid Date"
      ) {
        edd = format(data.ancedd, "yyyy-MM-dd");
      }
      if (
        data.eddbyNT !== null &&
        data.eddbyNT !== undefined &&
        data.eddbyNT !== "Invalid Date"
      ) {
        eddBynt = format(data?.eddbyNT, "yyyy-MM-dd");
      }
      if (
        data.eddbyU1 !== null &&
        data.eddbyU1 !== undefined &&
        data.eddbyU1 !== "Invalid Date"
      ) {
        eddbyU1 = format(data.eddbyU1, "yyyy-MM-dd");
      }
      let isLactating;
      if (data.yes === true) {
        isLactating = true;
      } else if (data.no === true) {
        isLactating = false;
      }

      let gravidaDetailsData = [];
      if (divData?.length > 0) {
        for (let dataObject of divData) {
          let gravidaObject = {
            deliveryMode: dataObject?.modeOfDelivery,
            age: Number(dataObject?.age),
            gender: dataObject?.gender,
            otherInfo: dataObject?.otherInfo,
          };
          gravidaDetailsData.push(gravidaObject);
        }
      }

      let postObj = {
        menstrualRegular: data?.menstrualRegular,
        menstrualDuration: data?.menstrualDuration,
        menstrualLength: data?.menstrualLength,
        menstrualLevel:
          data?.isHeavy === true
            ? "Heavy"
            : data?.isNormal === true
              ? "Normal"
              : "",
        menstrualPain:
          data?.painLess === true
            ? "Painless"
            : data?.painFull === true
              ? "Painfull"
              : "",

        ancUsgInfo: sonographyDetails?.length > 0 ? sonographyDetails : [],
        treatmentAdviceDescription: adviceDescription,
        medicalHistory: data?.medicalHistory,
        draftFlag: isDraft,
        department: patientData?.department,
        parentEmrId: parentId,
        unitId: userRole.unitId,
        visitId: visitId,
        patientId: patientId,
        referralDoctors: dataRef,
        isAnc: ancWatch,
        isAncClosed: isAncClose,
        menstrualHistory: data.menstrualHistory,
        admissionTentativeDate: adviceDetails?.admissionTentativeDate,
        stayLength: adviceDetails?.stayLength,
        admittingDepartmentId: adviceDetails?.admittingDepartmentId,
        admittingDepartment: adviceDetails?.admittingDepartment,
        admittingDoctorId: adviceDetails?.admittingDoctorId,
        admittingDoctor: adviceDetails?.admittingDoctor,
        generalInstructions:
          generalInstraction?.length > 0 ? generalInstraction : null,
        isOpd: true,
        vitals: {
          bloodPressureDiastolic:
            Number(data.bpDiastolic) !== 0 ? Number(data.bpDiastolic) : null,
          bloodPressureSystolic:
            Number(data.bpSystolic) !== 0 ? Number(data.bpSystolic) : null,
          bloodSugar: Number(data.bsl) !== 0 ? Number(data.bsl) : null,
          bmi: Number(data.bmi) !== 0 ? Number(data.bmi) : null,
          bsa: Number(data.bsa) !== 0 ? Number(data?.bsa) : null,
          height: Number(data.height) !== 0 ? Number(data.height) : null,
          pulseRate:
            Number(data.pulseRate) !== 0 ? Number(data.pulseRate) : null,
          respiration:
            Number(data.respiration) !== 0 ? Number(data.respiration) : null,
          spO2: Number(data.spO2) !== 0 ? Number(data.spO2) : null,
          temperature: Number(data.temp) !== 0 ? Number(data.temp) : null,
          weight: Number(data.weight) !== 0 ? Number(data.weight) : null,
          urineAlbumin: data?.urineAlbumin !== "" ? data?.urineAlbumin : "",
        },
        bloodGroup: data.bloodGroup,
        allergies:
          allergiesDetailslist?.length > 0 ? allergiesDetailslist : null,
        documents: documentsDataResult?.length > 0 ? documentsDataResult : null,
        complaints:
          presentingComplaintsDataResultTemp?.length > 0
            ? presentingComplaintsDataResultTemp
            : null,
        pastHistory: {
          dmDescription: data.DM !== "" ? data.DM : null,
          htnDescription: data.HTN !== "" ? data.HTN : null,
          heartDiseaseDescription:
            data.heartDisease !== "" ? data.heartDisease : null,
          surgicalHistory:
            data.surgicalHistory !== "" ? data.surgicalHistory : null,
          familyHistory: data.familyHistory !== "" ? data.familyHistory : null,
          otherHistory:
            data.pastOtherHistory !== "" ? data.pastOtherHistory : null,
          smokingFlag: data?.smoke,
          smokingHistory:
            data?.smokeDescription !== "" ? data?.smokeDescription : null,
          alcoholFlag: data?.alohol,
          alcoholHistory:
            data?.aloholDescription !== "" ? data?.aloholDescription : null,
          tobaccoFlag: data?.tobacco,
          tobaccoHistory:
            data?.tobaccoDiseaseDescription !== ""
              ? data?.tobaccoDiseaseDescription
              : null,
          dietFlag: data?.diet,
          dietHistory:
            data?.dietDescription !== "" ? data?.dietDescription : null,
          vegFlag: data?.veg,
          vegHistory: data?.vegDescription !== "" ? data?.vegDescription : null,
          nonVegFlag: data?.nonveg,
          nonVegHistory: data?.nonvegDescription,
        },

        presentIllnessHistory:
          (ancWatch === true && data?.hopiAnc !== "") ||
          (ancWatch === true && data?.hopiAnc !== undefined)
            ? data?.hopiAnc
            : data?.hopi,
        menstrualHistory: data.menstrualHistory,
        obstetricHistory: {
          eddByNt: eddBynt !== null ? eddBynt : null,
          eddByU1: eddbyU1 !== null ? eddbyU1 : null,
          lmp: datelmp,
          conception: dateconception,
          cycleLength: Number(data.cycleLength),
          edd: dateedd,
          gravida: Number(data.gravida),
          para: data.para,
          living: Number(data.living),
          abortions: Number(data.abortion),
          gravidaDetails: gravidaDetailsData,
          otherHistory: data.otherHistory,
          isLactating: isLactating,
          lastChildBirth: data.lastChildBirth,
        },
        examinations: {
          cns: data?.cns,
          cvs: data.cvs,
          leftSideBreastExamination: data?.leftSideBreastExmination,
          pa: data.pa,
          ps: data.ps,
          pv: data.pv,
          rightSideBreastExamination: data?.rightSideBreastExmination,
          rs: data.rs,
          pr: data?.pr,
          speculum: data?.speculum,
          perRectalExamination: data?.perRectalexam,
          localExamination: data?.systemlocalExamination,
          onExamination: data?.onExamination,
        },
        diagnosis:
          diagnosisOfIndexCancerDataResultTemp?.length > 0
            ? diagnosisOfIndexCancerDataResultTemp
            : null,
        date: format(data?.date, "yyyy-MM-dd"),
        gestureAge: data?.gestureAge,
        fetalPosition: data?.fetalPosition,
        fetalHeart: data?.fetalHeart,
        liquor: data?.liquor,
        placenta: data?.placenta,
        doppler: data?.doppler,
        patientSurgeryAdviseDetails:
          tempSurgery[0]?.surgerySurgeonDetails?.length > 0
            ? tempSurgery
            : null,
        treatmentAdvices: checkedNames?.length > 0 ? checkedNames : null,
        pathology: pathologyDataResult?.length > 0 ? pathologyDataResult : null,
        radiology: radiologyDataResult?.length > 0 ? radiologyDataResult : null,
        services: servicesDataResult?.length > 0 ? servicesDataResult : null,
        nextFollowDate: FollowDate,
        followUpDepartment: data.department?.label,
        followUpDoctor: data.doctor?.label,
        followUpDepartmentId: data.department?.id,
        followUpDoctorId: data.doctor?.id,
        surgicalHistory: data.surgicalHistory,
        familyHistory: data.familyHistory,
        highRiskFactors:
          (ancWatch === true && data?.highRiskAnc !== "") ||
          (ancWatch === true && data?.highRiskAnc !== undefined)
            ? data?.highRiskAnc
            : data?.highRisk,
        immediateManagementCarePlan:
          data?.immediateManagement !== "" ? data?.immediateManagement : null,
        provideMeasuresCarePlan:
          data?.provideMeasuresifany !== "" ? data?.provideMeasuresifany : null,
        isDayCare: data?.DayCare,
        otherInfo: {
          presentation: data.presentation,
          fhs: data.fhs,
          pallor: data?.pallor,
          edema: data?.edema,
          ua: data?.ua,
          vaginalExam: data?.varginalExam,
          fs: data?.fs,
          fundalHeight: data?.fundalHeight,
        },
        ancNote: data.Ancnote,
        notes: data.noteFollowup,
        prescriptions:
          medicationDataResult?.length > 0 ? medicationDataResult : null,
        plan: data?.Ancplan,
        partnerDetails: partnerDetailsFill?.some(
          (val) => val !== null && val !== 0,
        )
          ? partnerDetails
          : null,
        patientDetails: patientDetailsFill?.some(
          (val) => val !== null && val !== 0,
        )
          ? patientDetailsANC
          : null,
      };

      // setOpenPost(true);
      setNewDoc(false);
      setFinalData(postObj);
      if (isDirty) {
        warningAlert("Please Enter Correct Entries..!!");
      } else {
        setOpenPost(true);
      }
    }
  };

  function SaveGynacEmr() {
    setOpenPost(false);
    setOpenBackdrop(true);
    // saveGynacEMR(finalData)
    //   .then((response) => {
    //     if (response.status === 200) {
    //       if (response.data.statusCode === 200) {
    //         setSaveData(false);
    //         successAlert(response.data.message);
    //         // if (isPrints) {
    //         //   //Prints Modal Open Here
    //         //   setOpenPrintModal(true);
    //         // } else {
    //         if (patientData?.admissionId > 0) {
    //           close();
    //         } else {
    //           navigate(
    //             "/opd/visitlist",
    //             { state: { menuId: location?.state?.visitListMenuId } },
    //             { replace: true },
    //           );
    //         }
    //         // }
    //       } else {
    //         setSaveData(false);
    //         errorAlert(response.data.message);
    //       }
    //       setSaveData(false);
    //       setOpenBackdrop(false);
    //     }
    //   })
    //   .catch((err) => {
    //     errorAlert(err.message);
    //     setSaveData(false);
    //     setOpenBackdrop(false);
    //   });
  }
  let getDefaultPrinter = JSON.parse(localStorage.getItem("defaultPrinters"));

  function arrayBufferToBase64(buffer) {
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  const saveEMRGeneralWithPrint = () => {
    setOpenPost(false);
    setOpenBackdrop(true);
    // saveGynacEMR(finalData)
    //   .then((response) => {
    //     if (response.status === 200) {
    //       if (response.data.statusCode === 200) {
    //         setSaveData(false);
    //         successAlert(response.data.message);
    //         if (getDefaultPrinter !== undefined && getDefaultPrinter !== null) {
    //           getPrescription(visitId, false, userRole.employeeId).then(
    //             (response) => {
    //               getmedictionPrint(response);
    //             },
    //           );
    //         } else {
    //           setOpenPrint(true);
    //         }
    //       } else {
    //         setSaveData(false);
    //         errorAlert(response.data.message);
    //       }
    //       setSaveData(false);
    //       setOpenBackdrop(false);
    //     }
    //   })
    //   .catch((err) => {
    //     errorAlert(err.message);
    //     setSaveData(false);
    //     setOpenBackdrop(false);
    //   });
  };

  const pad2 = (value) => String(value).padStart(2, "0");

  useEffect(() => {
    let usgInfo = editData?.ancUsgInfo;

    let dataArray = [];

    if (usgInfo?.length > 0) {
      for (let responseObject of usgInfo) {
        let usgObject = {
          date: responseObject?.["usgDate"]
            ? `${responseObject.usgDate[0]}-${pad2(
                responseObject.usgDate[1],
              )}-${pad2(responseObject.usgDate[2])}`
            : null,

          gestureAge: responseObject?.gestureAge,
          "GA By Date": responseObject?.gaByDate,
          "Gestational Age (USG)": responseObject?.gestureAge,
          gaByDate: responseObject?.gaByDate,
          fetalPosition: responseObject?.fetalPosition,
          "Fetal Position": responseObject?.fetalPosition,
          fetalHeart: responseObject?.fetalHeart,
          "Fetal Heart": responseObject?.fetalHeart,
          liquor: responseObject?.liquor,
          placenta: responseObject?.placenta,
          doppler: responseObject?.doppler,
        };
        dataArray.push(usgObject);
        setUsgSonographyDetails(dataArray);
      }
    }

    // ####################  Menstrual History  ############################

    methods.setValue("menstrualRegular", editData?.menstrualRegular);
    methods.setValue("menstrualDuration", editData?.menstrualDuration);
    methods.setValue("menstrualLength", editData?.menstrualLength);

    if (editData?.menstrualLevel === "Heavy") {
      methods.setValue("isHeavy", true);
    } else if (editData?.menstrualLevel === "Normal") {
      methods.setValue("isNormal", true);
    }

    if (editData?.menstrualPain === "Painless") {
      methods.setValue("painLess", true);
    } else if (editData?.menstrualPain) {
      methods.setValue("painFull", true);
    }

    // ####################  Menstrual History  ############################

    if (editData !== null && editData !== undefined) {
      let newArr2 = [...dataRef];
      if (editData?.referralDoctors !== null) {
        const referralDoctors = editData.referralDoctors;
        for (let obj of referralDoctors) {
          const doctor = JSON.parse(obj.doctor);
          const department = obj.department ? JSON.parse(obj.department) : null;
          newArr2.push({
            doctorId: doctor.id,
            departmentId: department?.id,
            doctor: doctor.label,
            department: department ? department.label : undefined,
            referralNote: obj?.referralNote,
          });
        }

        // Update the state with the new array
        setDataRef(newArr2);
      }
      // ancNote:data.Ancnote,
      methods.setValue("Ancnote", editData?.ancNote);
      methods.setValue(
        "adviceDescription",
        editData?.treatmentAdviceDescription,
      );

      let newArr = [...allergiesData];
      if (editData?.allergies !== null) {
        for (let obj of editData?.allergies) {
          newArr.push({
            allergy: obj.allergyType,
            description: obj?.allergyDescription,
          });
          setAllergiesData(newArr);
          setDataAllergies(newArr);
        }
      }
      if (editData?.surgeryDetails?.length > 0) {
        methods.setValue("adviceSurgery", true);
      }

      if (editData !== null) {
        let newArr = [...complaintsData];
        if (editData?.complaints !== null) {
          for (let obj of editData?.complaints) {
            newArr.push({
              complaint: obj?.complaint,
              since: obj?.since,
              duration: obj.duration,
              // Duration: obj?.duration,
            });
            setComplaintsData(newArr);
            setDataComplains(newArr);
          }
        }
      }
      if (editData.generalInstructions?.length > 0) {
        let newArray = [...dataInstruction];
        for (let obj of editData?.generalInstructions) {
          newArray.push({
            instruction: obj,
          });
        }
        setInstractionDataResult(newArray);
        setDataInstruction(newArray);
      }
      if (editData?.bloodGroup !== null) {
        methods.setValue("bloodGroup", editData?.bloodGroup);
      }
      if (editData?.isAnc === true) {
        methods.setValue("anc", true);
      }
      methods.setValue("DM", editData?.pastHistory?.dmDescription);
      methods.setValue("HTN", editData?.pastHistory?.htnDescription);
      methods.setValue(
        "heartDisease",
        editData?.pastHistory?.heartDiseaseDescription,
      );
      methods.setValue(
        "surgicalHistory",
        editData?.pastHistory?.surgicalHistory,
      );
      methods.setValue("smoke", editData?.pastHistory?.smokingFlag);
      methods.setValue(
        "smokeDescription",
        editData?.pastHistory?.smokingHistory,
      );
      methods.setValue("alohol", editData?.pastHistory?.alcoholFlag);
      methods.setValue(
        "aloholDescription",
        editData?.pastHistory?.alcoholHistory,
      );
      methods.setValue("tobacco", editData?.pastHistory?.tobaccoFlag);
      methods.setValue(
        "tobaccoDiseaseDescription",
        editData?.pastHistory?.tobaccoHistory,
      );
      // methods.setValue("diet", editData?.pastHistory?.dietFlag);
      methods.setValue("veg", editData?.pastHistory?.vegFlag);
      methods.setValue("vegDescription", editData?.pastHistory?.vegHistory);
      methods.setValue("nonveg", editData?.pastHistory?.nonVegFlag);
      methods.setValue(
        "nonvegDescription",
        editData?.pastHistory?.nonVegHistory,
      );
      methods.setValue("familyHistory", editData?.pastHistory?.familyHistory);
      methods.setValue("pastOtherHistory", editData?.pastHistory?.otherHistory);

      if (editData?.isAnc === true) {
        methods.setValue("hopiAnc", editData?.presentIllnessHistory);
      } else {
        methods.setValue("hopi", editData?.presentIllnessHistory);
      }

      let LMP;
      if (
        editData?.obstetricHistory?.lmp !== null &&
        editData?.obstetricHistory?.lmp !== undefined
      ) {
        LMP = new Date(editData?.obstetricHistory?.lmp);
      }

      methods.setValue("lmp", LMP !== undefined ? LMP : null);
      methods.setValue("Anclmp", LMP !== undefined ? LMP : null);

      let conceptionDate;
      if (
        editData?.obstetricHistory?.conception !== null &&
        editData?.obstetricHistory?.conception !== undefined
      ) {
        conceptionDate = new Date(editData?.obstetricHistory?.conception);
      }
      methods.setValue(
        "conception",
        conceptionDate !== undefined ? conceptionDate : null,
      );
      methods.setValue("cycleLength", editData?.obstetricHistory?.cycleLength);
      let eddDate;
      if (
        editData?.obstetricHistory?.edd !== null &&
        editData?.obstetricHistory?.edd !== undefined
      ) {
        eddDate = new Date(editData?.obstetricHistory?.edd);
      }

      // methods.setValue("edd", eddDate !== undefined ? eddDate : null);

      if (eddDate !== undefined) {
        methods.setValue("isPregnant", true);
      }
      methods.setValue("ancedd", eddDate !== undefined ? eddDate : null);
      let eddByNtDate;
      if (
        editData?.obstetricHistory?.eddByNt !== null &&
        editData?.obstetricHistory?.eddByNt !== undefined
      ) {
        eddByNtDate = new Date(editData?.obstetricHistory?.eddByNt);
      }
      methods.setValue(
        "eddbyNT",
        eddByNtDate !== undefined ? eddByNtDate : null,
      );
      let eddbyU1Date;
      if (
        editData?.obstetricHistory?.eddByU1 !== null &&
        editData?.obstetricHistory?.eddByU1 !== undefined
      ) {
        eddbyU1Date = new Date(editData?.obstetricHistory?.eddByU1);
      }
      methods.setValue(
        "eddbyU1",
        eddbyU1Date !== undefined ? eddbyU1Date : null,
      );
      if (editData !== null) {
        if (
          editData?.obstetricHistory !== null &&
          editData?.obstetricHistory !== undefined &&
          editData?.obstetricHistory !== ""
        ) {
          let newArr = [...divData];
          if (
            editData?.obstetricHistory?.gravidaDetails !== null &&
            editData?.obstetricHistory?.gravidaDetails?.length > 0 &&
            editData?.obstetricHistory?.gravidaDetails !== undefined
          ) {
            for (let obj of editData?.obstetricHistory?.gravidaDetails) {
              newArr.push({
                modeOfDelivery: obj?.deliveryMode,
                gender: obj?.gender,
                age: obj?.age,
                otherInfo: obj?.otherInfo,

                // Duration: obj?.duration,
              });
              setDivData(newArr);
            }
          }
        }
      }
      methods.setValue("gravida", editData?.obstetricHistory?.gravida);
      methods.setValue("para", editData?.obstetricHistory?.para);
      methods.setValue("living", editData?.obstetricHistory?.living);
      methods.setValue("abortion", editData?.obstetricHistory?.abortions);
      methods.setValue(
        "otherHistory",
        editData?.obstetricHistory?.otherHistory,
      );
      if (editData?.obstetricHistory?.isLactating === true) {
        methods.setValue("yes", true);
      } else if (editData?.obstetricHistory?.isLactating === false) {
        methods.setValue("no", true);
      }
      methods.setValue(
        "lastChildBirth",
        editData?.obstetricHistory?.lastChildBirth,
      );
      let followDate;
      if (editData?.nextFollowDate !== null) {
        followDate = new Date(editData.nextFollowDate);
      }

      methods.setValue("nextFollowupDate", followDate);
      // if (editData !== null) {
      //   let newArr = [...diagnosisData];
      //   if (editData?.diagnosis !== null) {
      //     for (let obj of editData?.diagnosis) {
      //       newArr.push({
      //         diagnosis: obj?.icd,
      //         since: obj?.since,
      //         status: obj.status,
      //         chronic: obj.isChronic,
      //         duration: obj?.duration,
      //       });
      //       methods.setValue("diagnosis", obj?.icd);
      //       setDiagnosisData(newArr);
      //       setDataDiagnosis(newArr);
      //     }
      //   }
      // }

      if (editData !== null) {
        let newArr = [...diagnosisData];
        if (editData?.diagnosis !== null) {
          for (let obj of editData?.diagnosis) {
            newArr.push({
              diagnosis: obj?.icd,
              since: obj?.since,
              duration: obj.duration,
              status: obj?.status || "",
              chronic: obj.isChronic,
              // Duration: obj?.duration,
            });
            setDiagnosisData(newArr);
            setDataDiagnosis(newArr);
          }
        }
      }
      if (editData !== null) {
        let newArr = [...serviceData];
        if (editData?.services !== null) {
          for (let obj of editData?.services) {
            newArr.push({
              service: obj?.serviceName,
              quantity: obj?.quantity,
              id: obj?.id,
              serviceId: obj?.serviceId,
              isBilled: obj?.isBilled,
              isDeleteFlag: false,
              isTemplate: false,
            });
            setServiceData(newArr);
            setDataServices(newArr);
          }
        }
      }

      methods.setValue("temp", editData?.vitals?.temperature);
      methods.setValue("pulseRate", editData?.vitals?.pulseRate);
      methods.setValue("bpSystolic", editData?.vitals?.bloodPressureSystolic);
      methods.setValue("bpDiastolic", editData?.vitals?.bloodPressureDiastolic);
      methods.setValue("medicalHistory", editData?.medicalHistory);
      methods.setValue("spO2", editData?.vitals?.spO2);
      methods.setValue("weight", editData?.vitals?.weight);
      methods.setValue("urineAlbumin", editData?.vitals?.urineAlbumin);
      methods.setValue("height", editData?.vitals?.height);
      methods.setValue("bmi", editData?.vitals?.bmi);
      methods.setValue("respiration", editData?.vitals?.respiration);
      methods.setValue("bsl", editData?.vitals?.bloodSugar);

      if (editData !== null) {
        let newArr = [...pathologyData];
        if (editData?.pathology !== null) {
          for (let obj of editData?.pathology) {
            newArr.push({
              service: obj.investigation,
              urgent: obj?.isUrgent,
              testId: obj?.testId,
              isNew: false,
              isService: false,
              isDeleteFlag: false,
              id: obj?.id,
              serviceId: obj.serviceId,
              isBilled: obj?.isBilled,
              orderId: obj?.orderId,
              isWorkOrderCreated: obj?.isWorkOrderCreated,
            });

            console.log("The data in the EMR pathology services is :", newArr);

            setPathologyData(newArr);
            setDataPathology(newArr);
          }
        }
      }
      if (editData !== null) {
        let newArr = [...radiologyData];
        if (editData?.radiology !== null) {
          for (let obj of editData?.radiology) {
            newArr.push({
              service: obj.investigation,
              urgent: obj?.isUrgent,
              testId: obj?.testId,
              isService: false,
              isDeleteFlag: false,
              id: obj?.id,
              status: obj?.status,
              serviceId: obj.serviceId,
              isBilled: obj?.isBilled,
              orderId: obj?.orderId,
              // Duration: obj?.duration,
            });
            setRadiologyData(newArr);
            setDataRadiology(newArr);
          }
        }
      }

      let departmentObj = {
        id: editData.followUpDepartmentId,
        label: editData.followUpDepartment,
        value: editData.followUpDepartment,
      };
      let departmentDefaultObj = {
        id: patientData?.departmentId,
        value: patientData?.department,
        label: patientData?.department,
      };
      methods.setValue(
        "department",
        departmentObj?.id !== null ? departmentObj : departmentDefaultObj,
      );
      let doctorObj = {
        id: editData.followUpDoctorId,
        label: editData.followUpDoctor,
        value: editData.followUpDoctor,
      };
      let doctorDefaultObj = {
        id: patientData.doctorId,
        value: patientData.doctor,
        label: patientData.doctor,
      };
      methods.setValue(
        "doctor",
        doctorObj?.id !== null ? doctorObj : doctorDefaultObj,
      );
      methods.setValue("noteFollowup", editData?.notes);

      methods.setValue("rs", editData?.examinations?.rs);
      methods.setValue("cvs", editData?.examinations?.cvs);
      methods.setValue("pa", editData?.examinations?.pa);
      methods.setValue(
        "systemlocalExamination",
        editData?.examinations?.localExamination,
      );
      methods.setValue("ps", editData?.examinations?.ps);
      methods.setValue("pv", editData?.examinations?.pv);
      methods.setValue("pr", editData?.examinations?.pr);
      methods.setValue("speculum", editData?.examinations?.speculum);
      methods.setValue("cns", editData?.examinations?.cns);
      methods.setValue(
        "perRectalexam",
        editData?.examinations?.perRectalExamination,
      );

      methods.setValue(
        "leftSideBreastExmination",
        editData?.examinations?.leftSideBreastExamination,
      );
      methods.setValue(
        "rightSideBreastExmination",
        editData?.examinations?.rightSideBreastExamination,
      );
      methods.setValue("onExamination", editData?.examinations?.onExamination);
      methods.setValue(
        "immediateManagement",
        editData?.immediateManagementCarePlan,
      );
      methods.setValue(
        "provideMeasuresifany",
        editData?.provideMeasuresCarePlan,
      );
      methods.setValue("DayCare", editData?.isDayCare);

      if (editData?.isAnc === true) {
        methods.setValue("highRiskAnc", editData?.highRiskFactors);
      } else {
        methods.setValue("highRisk", editData?.highRiskFactors);
      }

      methods.setValue("Ancplan", editData?.plan);
      methods.setValue("fundalHeight", editData?.otherInfo?.fundalHeight);
      methods.setValue("presentation", editData?.otherInfo?.presentation);
      methods.setValue("fhs", editData?.otherInfo?.fhs);
      methods.setValue("pallor", editData?.otherInfo?.pallor);
      methods.setValue("edema", editData?.otherInfo?.edema);
      methods.setValue("ua", editData?.otherInfo?.ua);
      methods.setValue("varginalExam", editData?.otherInfo?.vaginalExam);
      methods.setValue("fs", editData?.otherInfo?.fs);

      if (editData !== null) {
        let newArr = [...surgeryData];
        if (editData?.surgeryDetails !== null) {
          for (let obj of editData?.surgeryDetails) {
            newArr.push({
              surgery: obj.surgeon,
              surgeon: obj?.surgery,
              surgeonId: obj.surgeonId,
              surgeryId: obj?.surgeryId,
            });
            setSurgeryData(newArr);
            setDataSurgery(newArr);
          }
        }
      }
      methods.setValue("menstrualHistory", editData?.menstrualHistory);

      if (editData !== null) {
        let newArr = [...medicationData];
        if (editData?.prescriptions !== null) {
          for (let obj of editData?.prescriptions) {
            newArr.push({
              drugType: obj.drugType,
              drugName: obj?.drugName,
              frequency: obj?.frequency,
              instruction: obj?.instruction,
              duration: obj?.duration,
              route: obj?.route,
              quantity: obj?.quantity,
              dosage: obj?.dosage,
              ivFlowRate: obj?.ivFlowRate,
              startDate: obj?.startDate,
              note: obj?.notes,
              id: obj?.id,
              durationIn: obj?.durationIn,
              drugTapering: obj.drugTapering,
              isParent: obj.isParent,
              drugId: obj.drugId,
            });
            setMedicationData(newArr);
            setDataMedication(newArr);
          }
        }
      }

      let tempGeneralExist = [...fields];
      let tempOtherExamination = editData?.treatmentAdvices;
      for (let g = 0; g < tempGeneralExist?.length; g++) {
        for (let t = 0; t < tempOtherExamination?.length; t++) {
          if (tempGeneralExist[g]?.name === tempOtherExamination[t]) {
            tempGeneralExist[g].checked = true;
          }
        }
        setFields(tempGeneralExist);
      }
      if (editData !== null) {
        let tempDocuments = [];
        if (editData?.documents !== null && editData?.documents !== undefined) {
          for (let obj of editData?.documents)
            for (let val of JSON.parse(obj?.docpath)) {
              tempDocuments.push({
                documentType: obj.documentType,
                document: obj?.documentName,
                documentView: val?.filePath,
                documentFile: null,
                documentDescription: val?.documentDescription,
                isNew: false,
              });
              setDataDocument(tempDocuments);
              setDocumentData(tempDocuments);
              setNewDoc(false);
            }
        }
      }
      methods.setValue("name", editData?.partnerDetails?.name);
      methods.setValue("age", editData?.partnerDetails?.currentAge);
      methods.setValue(
        "partnerAgeDuringMarriage",
        editData?.partnerDetails?.ageDuringMarriage,
      );
      methods.setValue("partnerEducation", editData?.partnerDetails?.education);
      methods.setValue(
        "partnerOccupation",
        editData?.partnerDetails?.occupation,
      );
      methods.setValue("partnerAadharNo", editData?.partnerDetails?.aadharNo);
      methods.setValue("partnerMobileNo", editData?.partnerDetails?.mobileNo);

      methods.setValue(
        "patientAgeDuringMarriage",
        editData?.patientDetails?.ageDuringMarriage,
      );
      methods.setValue("patientEducation", editData?.patientDetails?.education);
      methods.setValue(
        "patientOccupation",
        editData?.patientDetails?.occupation,
      );
      methods.setValue("patientAadharNo", editData?.patientDetails?.aadharNo);
      methods.setValue("patientMobileNo", editData?.patientDetails?.mobileNo);
    }
  }, [editData]);

  const handleForcefullyCloseFun = () => {
    methods.setValue("anc", false);
    setIsAncClose(true);
    setOpenConfirmationModal(false);
  };

  function viewLIMSHistory() {
    // getPathologyHistory(patientId, visitId).then((response) => {
    //   const chekedKey = response.data.result.map((item) => ({
    //     ...item,
    //     isChecked: false,
    //   }));
    //   setPathHistoryData(chekedKey);
    // });
  }

  function viewLimsRadiologyHistory() {
    // getRadiologyHistory(patientId, visitId).then((response) => {
    //   setRadioHistoryData(response.data.result);
    // });
  }

  const handleChangeTem = (e) => {
    if (e?.length > 0) {
      templateSearch(e, userRole.unitId).then((response) => {
        setTemplateOption(response.data.result);
      });
    }
  };

  let bloodgroupValue = methods.watch("bloodGroup");

  let template = methods.watch("template");

  let templateIds = template?.map((row) => row?.id);

  useEffect(() => {
    let tempObj = {
      templateIds: templateIds,
    };
    getTemplateMultipleData(tempObj).then((response) => {
      setTemplateDataDetails(response.data.result);
    });
  }, [template]);

  const parseTreatmentAdvices = (input) => {
    if (!input) return [];

    if (Array.isArray(input)) {
      return input.flatMap((item) => parseTreatmentAdvices(item));
    }

    if (typeof input === "string") {
      try {
        const parsed = JSON.parse(input);

        if (Array.isArray(parsed)) {
          return parsed;
        }
      } catch {}

      const matches = input.match(/\[[^\]]*\]/g) || [];

      return matches.flatMap((part) => {
        try {
          const parsed = JSON.parse(part);
          return Array.isArray(parsed) ? parsed : [];
        } catch {
          return [];
        }
      });
    }

    return [];
  };

  useEffect(() => {
    if (templateDataDetail !== null && templateDataDetail !== undefined) {
      if (templateDataDetail !== null) {
        let newArr = [...complaintsData];
        if (templateDataDetail?.complaints !== null) {
          let complaintsArray = [];
          for (let obj of templateDataDetail?.complaints) {
            complaintsArray.push(obj.complaint);

            methods.setValue("complaints", complaintsArray.join(", "));
          }
        }
      }

      if (
        templateDataDetail !== null &&
        templateDataDetail !== undefined &&
        templateDataDetail.instructions?.length > 0
      ) {
        let newArray = [...dataInstruction];
        let instruction = [];
        for (let obj of templateDataDetail?.instructions) {
          instruction.push(obj.instructions);
        }
        methods.setValue("instruction", instruction.join(", "));
      }

      if (templateDataDetail !== null && templateDataDetail !== undefined) {
        let newArr = [...diagnosisData];
        if (templateDataDetail?.diagnosis !== null) {
          let diagnosis = [];
          for (let obj of templateDataDetail?.diagnosis) {
            diagnosis.push(obj.icd);

            methods.setValue("diagnosis", diagnosis.join(", "));
          }
        }
      }
      if (templateDataDetail !== null && templateDataDetail !== undefined) {
        let newArr = [...medicationData];
        if (templateDataDetail?.prescription !== null) {
          for (let obj of templateDataDetail?.prescription) {
            newArr.push({
              drugType: obj.drugType,
              drugName: obj?.drugName,
              frequency: obj?.frequency,
              instruction: obj?.instruction,
              duration: obj?.duration !== undefined ? obj?.duration : "",
              route: obj?.route,
              quantity: obj?.quantity,
              dosage: obj?.dosage,
              ivFlowRate: obj?.ivFlowRate,
              startDate: obj?.startDate,
              note: obj?.notes,
              id: obj.id,
              code: obj.code,
              durationIn: obj?.durationIn,
              drugTapering: obj.drugTapering,
              isParent: obj.isParent,
              drugId: obj.drugId,
            });
            setMedicationData(newArr);
            setDataMedication(newArr);
          }
        }
      }

      if (templateDataDetail !== null && templateDataDetail !== undefined) {
        let newArr = [...pathologyData];
        if (templateDataDetail?.pathology !== null) {
          for (let obj of templateDataDetail?.pathology) {
            newArr.push({
              service: obj.testName,
              urgent: obj?.isUrgent,
              testId: obj?.testId,
              serviceId: obj.serviceId,
              id: obj.id,
              isNew: false,
              isLab: true,
              isDeleteFlag: false,
              status: obj?.status,
              isTempDelete: false,
            });
            setPathologyData(newArr);
            setDataPathology(newArr);
          }
        }
        let dataArray = [...serviceData];

        let newLabServices = [
          ...templateDataDetail?.pathology,
          ...templateDataDetail?.radiology,
        ];
        if (newLabServices?.length > 0) {
          for (let obj of newLabServices) {
            let serviceObject = {
              service: obj?.service || obj.testName,
              quantity: 1,
              id: obj?.id,
              serviceId: obj?.serviceId,
              isBilled: false,
              isDeleteFlag: false,
              isTempDelete: false,
              isLab: true,
              isTemplate: true,
            };
            dataArray.push(serviceObject);
            setServiceData(dataArray);
          }
        }
      }

      if (templateDataDetail !== null && templateDataDetail !== undefined) {
        let newArr = [...radiologyData];
        if (templateDataDetail?.radiology !== null) {
          for (let obj of templateDataDetail?.radiology) {
            newArr.push({
              service: obj.testName,
              urgent: obj?.isUrgent,
              testId: obj?.testId,
              serviceId: obj.serviceId,
              id: obj.id,
              isLab: true,
              isDeleteFlag: false,
              isNew: false,
            });
            setRadiologyData(newArr);
            setDataRadiology(newArr);
          }
        }
      }

      if (templateDataDetail?.treatmentAdvices !== null) {
        const tempOtherExamination = parseTreatmentAdvices(
          templateDataDetail?.treatmentAdvices,
        );

        let tempGeneralExist = [...fields];
        if (tempOtherExamination.length > 0) {
          tempGeneralExist = tempGeneralExist.map((item) => ({
            ...item,
            checked: tempOtherExamination.includes(item.name),
          }));

          setFields(tempGeneralExist);
        }
      }
    }
  }, [templateDataDetail]);

  useEffect(() => {
    getMarkFavorite().then((response) => {
      setMarkFavoriteData(response.data.result);
    });
  }, []);

  useEffect(() => {
    if (
      patientData?.patientId !== undefined &&
      userRole?.unitId !== undefined
    ) {
      getPatientVisitLisit(patientData?.patientId, userRole?.unitId).then(
        (response) => {
          setPatientVisitData(response.data.result);
        },
      );
    }
  }, [patientData?.patientId, userRole?.unitId]);
  useEffect(() => {
    if (selectedRow !== null) {
      let obj = {
        department: selectedRow?.department,
        patientInfoId: patientData?.patientId,
        visitIdList: [selectedRow?.visitId],
        visitNumber: [selectedRow?.visitNumber],
        doctorId: patientData?.doctorId,
      };
      // getOncologyPreviousVisitsData(obj).then((response) => {
      //   if (response.data?.statusCode === 200) {
      //     setPastData(response.data.result);
      //   }
      // });
    }
  }, [selectedRow]);

  useEffect(() => {
    if (patientDetails?.bloodGroup) {
      methods.setValue(
        "bloodGroup",
        patientDetails.bloodGroup === "A +" ||
          patientDetails.bloodGroup === "A+"
          ? "A+"
          : patientDetails.bloodGroup === "B +" ||
              patientDetails.bloodGroup === "B+"
            ? "B+"
            : patientDetails.bloodGroup === "AB +" ||
                patientDetails.bloodGroup === "AB+"
              ? "AB+"
              : patientDetails.bloodGroup === "O +" ||
                  patientDetails.bloodGroup === "O+"
                ? "O+"
                : patientDetails.bloodGroup === "A -" ||
                    patientDetails.bloodGroup === "A-"
                  ? "A-"
                  : patientDetails.bloodGroup === "B -" ||
                      patientDetails.bloodGroup === "B-"
                    ? "B-"
                    : patientDetails.bloodGroup === "AB -" ||
                        patientDetails.bloodGroup === "AB-"
                      ? "AB-"
                      : patientDetails.bloodGroup === "O -" ||
                          patientDetails.bloodGroup === "O-"
                        ? "O-"
                        : patientDetails.bloodGroup === "Null"
                          ? "Not Null"
                          : "Not Null",
      );
    }
  }, [patientDetails]);

  let DayCare = methods.watch("DayCare");

  useEffect(() => {
    if (DayCare !== true) {
      methods.setValue("opdNo", true);
    } else {
      methods.setValue("opdNo", false);
    }
  }, [DayCare]);
  useEffect(() => {
    let hasDayCare = false;
    if (editData?.treatmentAdvices !== null) {
      hasDayCare = editData?.treatmentAdvices?.includes("dayCare");
      if (hasDayCare) {
        methods.setValue("DayCare", hasDayCare);
      }
    }
    if (hasDayCare) {
      methods.setValue("opdNo", false);
    } else {
      methods.setValue("opdNo", true);
    }
  }, [editData]);

  return (
    <div className="mx-2">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <div
            className={`bg-slate-50 sticky z-30 ${
              patientData?.admissionId > 0 ? `top-0` : `top-0`
            } `}
          >
            {patientData?.admissionId > 0 ? (
              <div className="grid grid-cols-3 gap-2 items-center">
                <div></div>
                <div className="text-center text-[18px] font-semibold whitespace-nowrap pb-4 mt-4">
                  Gynaec EMR
                </div>
                <div className="flex justify-end">
                  <button
                    type="button"
                    onClick={() => {
                      close();
                    }}
                  >
                    <CloseModalIcon />
                  </button>
                </div>
              </div>
            ) : (
              <div>{CommonHeading("Gynaec EMR")}</div>
            )}
            <div>
              <PatientInfo
                patientDetails={patientData}
                editData={editData}
                patientInfoApi={patientDetails}
                bloodgroupValue={bloodgroupValue}
              />
            </div>
            <div className="bg-blue-50 rounded shadow my-2 px-2 py-1">
              <div className="flex justify-between my-auto">
                <div className="w-[50%] flex flex-wrap space-x-3">
                  <div>
                    <fieldset
                      className="w-[300px]"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                    >
                      <SearchDropdown
                        isDisabled={
                          (location?.state !== null &&
                            location?.state?.status === "Completed") ||
                          pastData !== null
                        }
                        control={methods.control}
                        name="template"
                        placeholder="Template"
                        dataArray={templateOption}
                        handleInputChange={handleChangeTem}
                        isClearable={true}
                        isMulti={true}
                        inputRef={{
                          ...methods.register("template", {
                            onChange: (e) => {
                              if (
                                e.target.value?.length === 0 ||
                                e.target.value === undefined
                              ) {
                                let dataArray = serviceData;
                                let filtered = dataArray.filter(
                                  (service) => service.isTemplate === false,
                                );
                                setServiceData(filtered);
                                setTemplateDataDetails(null);
                                setInstractionDataResult([]);
                                setDataInstruction([]);
                                setDiagnosisData([]);
                                setMedicationData([]);
                                setDataMedication([]);
                                setPathologyData([]);
                                setRadiologyData([]);
                                methods.setValue("complaints", "");
                                methods.setValue("instruction", "");
                                methods.setValue("diagnosis", "");
                                let tempGeneralExist = [...fields];
                                for (
                                  let g = 0;
                                  g < tempGeneralExist?.length;
                                  g++
                                ) {
                                  tempGeneralExist[g].checked = false;
                                }
                              } else if (e.target.value?.length === 1) {
                                let dataArray = serviceData;
                                let filtered = dataArray.filter(
                                  (service) => service.isTemplate === false,
                                );

                                setServiceData(filtered);
                                setInstractionDataResult([]);
                                setDataInstruction([]);
                                setDiagnosisData([]);
                                setMedicationData([]);
                                setPathologyData([]);
                                setRadiologyData([]);
                                methods.setValue("complaints", "");
                                methods.setValue("instruction", "");
                                methods.setValue("diagnosis", "");
                                let tempGeneralExist = [...fields];
                                for (
                                  let g = 0;
                                  g < tempGeneralExist?.length;
                                  g++
                                ) {
                                  tempGeneralExist[g].checked = false;
                                }
                              }
                            },
                          }),
                        }}
                      />
                    </fieldset>
                  </div>
                  <div>
                    <fieldset
                      onChange={(e) => {
                        if (e.target.checked === true) {
                          methods.setValue("DayCare", false);
                        }
                      }}
                    >
                      <CheckBoxField
                        control={methods.control}
                        label="OPD"
                        name="opdNo"
                      />
                    </fieldset>
                  </div>
                  <div>
                    <fieldset
                      onChange={(e) => {
                        if (e.target.checked === true) {
                          methods.setValue("opdNo", false);
                        }
                      }}
                    >
                      <CheckBoxField
                        control={methods.control}
                        label="Day Care"
                        name="DayCare"
                      />
                    </fieldset>
                  </div>
                </div>

                <div className="flex justify-end space-x-2 w-[50%]">
                  {/* <Tooltip title="Request For Investigations">
                    <button
                      onClick={() => {
                        setOpenRequestModal(true);
                      }}
                      type="button"
                      className="mr-7"
                    >
                      <img
                        alt="request"
                        src={InvestigationRequest}
                        height={"35px"}
                        width={"40px"}
                      />
                    </button>
                  </Tooltip> */}
                  <div>
                    <fields
                      onClick={(e) => {
                        setAncChecked(e.target.checked);
                      }}
                    >
                      <CheckBoxField
                        control={methods.control}
                        label="ANC"
                        name="anc"
                      />
                    </fields>
                  </div>

                  {/* <div>
                    <CheckBoxField
                      control={methods.control}
                      label="PNC"
                      name="pnc"
                    />
                  </div> */}
                  <div className="mt-2">
                    {/* <Tooltip title="">
                      <button
                        type="button"
                        onClick={(e) => {
                          setOpenGrowthChart(true);
                        }}
                      >
                        <GrowthIcon />
                      </button>
                    </Tooltip> */}
                  </div>
                  <div className="mt-1">
                    <Tooltip title="ANC WORKSHEET">
                      {ancWatch === true ? (
                        <button
                          type="button"
                          onClick={(e) => {
                            setOpenANCWorkSheet(true);
                          }}
                        >
                          <PergentIcon />
                        </button>
                      ) : (
                        ""
                      )}
                    </Tooltip>
                  </div>
                  <div className="mt-1">
                    <Tooltip title="ANC View">
                      {ancWatch === true ? (
                        <fields
                          onClick={(e) => {
                            //  setAncChecked(e.target.checked);
                            setOpenANCView(true);
                          }}
                        >
                          <CheckBoxField
                            control={methods.control}
                            label="ANC View"
                            name=""
                          />
                        </fields>
                      ) : (
                        ""
                      )}
                    </Tooltip>
                  </div>
                  <div>
                    {ancWatch === true ? (
                      <button
                        type="button"
                        onClick={(e) => {
                          setOpenConfirmationModal(true);
                        }}
                      >
                        <ForceFullIcon />
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                  <div>
                    {ancWatch === true ? (
                      <button
                        type="button"
                        onClick={() => {
                          setOpenPartnerModal(true);
                        }}
                      >
                        <PartnerInfo />
                      </button>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="mt-2">
                    <Tooltip
                      title="Pathology Report"
                      placement="top-start"
                      arrow
                    >
                      <button
                        type="button"
                        onClick={() => {
                          viewLIMSHistory();
                          setLIMSType("Pathology");
                          setOpenInvestigationModal(true);
                        }}
                      >
                        <RadiologyIcon />
                      </button>
                    </Tooltip>
                  </div>
                  <div className="mt-2">
                    <Tooltip
                      title="Radiology Report"
                      placement="top-start"
                      arrow
                    >
                      <button
                        type="button"
                        onClick={() => {
                          viewLimsRadiologyHistory();
                          setLIMSType("Radiology");
                          setOpenInvestigationModal(true);
                        }}
                      >
                        <PathologyIcon />
                      </button>
                    </Tooltip>
                  </div>

                  <div className="mt-2">
                    {location?.state?.status === "OnGoing" ? (
                      <Tooltip
                        title="Add Medication"
                        placement="top-start"
                        arrow
                      >
                        <button
                          type="button"
                          onClick={() => {
                            setOpenMedicationModal(true);
                          }}
                        >
                          <AddMedicationIcon />
                        </button>
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="mt-2">
                    <Tooltip title="Vitals Charts" placement="top-start" arrow>
                      <button
                        type="button"
                        onClick={() => {
                          setOpenViewVital(true);
                        }}
                      >
                        <VitalChart />
                      </button>
                    </Tooltip>
                  </div>

                  <div className="mt-2">
                    {/* <Tooltip title="History Sheet" placement="top-start" arrow>
                      <button
                        type="button"
                        onClick={() => {
                          // if (location.state.status === "Completed") {
                          setPatientHistory(true);
                          // }
                        }}
                      >
                        <HistorySheet />
                      </button>
                    </Tooltip> */}
                  </div>
                  <div>
                    {(location?.state?.status === "Confirmed" &&
                      userRole?.isDoctor === true) ||
                    (location?.state?.status === "Confirmed" &&
                      userRole?.role === "RMO") ||
                    (patientData?.admissionId > 0 &&
                      userRole?.isDoctor === true) ? (
                      <fieldset
                        onClick={() => {
                          setSaveData(true);
                          setIsDraft(true);
                        }}
                      >
                        <CommonButton
                          type="submit"
                          label="Save"
                          className="bg-customBlue text-white"
                        />
                      </fieldset>
                    ) : location?.state?.status === "OnGoing" &&
                      userRole?.isDoctor === true ? (
                      <fieldset
                        onClick={() => {
                          setSaveData(true);
                        }}
                      >
                        <CommonButton
                          type="submit"
                          label="Complete"
                          className="bg-customGreen text-white"
                        />
                      </fieldset>
                    ) : location?.state?.status === "Completed" &&
                      userRole?.isDoctor === true ? (
                      <fieldset
                        onClick={() => {
                          setSaveData(true);
                          setEdit(true);
                        }}
                      >
                        <CommonButton
                          type="submit"
                          label="Update"
                          className="bg-customGreen text-white"
                        />
                      </fieldset>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {ancWatch === false || ancWatch === undefined ? (
            <div className="w-full flex gap-1">
              <div className="w-full">
                <div className="grid md:grid-cols-2 xl:grid-cols-2 gap-2 ">
                  <div className="col-span-2 my-1">
                    <BloodGroup />
                  </div>

                  <div className="col-span-2 grid grid-cols-2 gap-2">
                    <HighRiskFactors />
                    <div className="">
                      <Vital
                        isDirty={isDirty}
                        setIsDirty={setIsDirty}
                        weight={weight}
                        setWeight={setWeight}
                        height={height}
                        setHeight={setHeight}
                        pastData={pastData}
                      />
                    </div>
                  </div>
                  <div className="col-span-2 grid grid-cols-3 gap-2 ">
                    <Complaints
                      patientHistoryData={patientHistoryData}
                      setPatientHistoryData={setPatientHistoryData}
                      complaintsData={complaintsData}
                      setComplaintsData={setComplaintsData}
                      dataComplaints={dataComplaints}
                      setDataComplains={setDataComplains}
                      markFavoriteData={markFavoriteData}
                    />
                    <Allergies
                      markFavoriteData={markFavoriteData}
                      allergiesData={allergiesData}
                      setAllergiesData={setAllergiesData}
                      dataAllergies={dataAllergies}
                      setDataAllergies={setDataAllergies}
                    />
                    <OPDDiagnosis
                      patientHistoryData={patientHistoryData}
                      setPatientHistoryData={setPatientHistoryData}
                      diagnosisData={diagnosisData}
                      setDiagnosisData={setDiagnosisData}
                      dataDiagnosis={dataDiagnosis}
                      setDataDiagnosis={setDataDiagnosis}
                      doctorId={userRole?.employeeId}
                      patientVisitedDepartmentId={patientVisitedDepartmentId}
                      markFavoriteData={markFavoriteData}
                    />
                  </div>
                  <div className="w-full my-1 ">
                    <GynacHOPI pastData={pastData} />
                  </div>

                  <div className="w-full m ">
                    <GyncMenstrualHistory pastData={pastData} />
                  </div>
                  <div className="col-span-2">
                    <GynacObstetricDetails pastData={pastData} />
                  </div>
                  <div>
                    <GynacExaminations pastData={pastData} />
                  </div>
                  <div>
                    <GynacPastHistory pastData={pastData} />
                  </div>
                  <div>
                    <Habit />
                  </div>
                  <div>
                    <PlanofCare from={"generalEMR"} />
                  </div>
                  <div className="w-full ">
                    <OPDMedicalHistory pastData={pastData} from={"gyanc"} />
                  </div>
                  <div className="">
                    <OPDDocuments
                      doctomentData={doctomentData}
                      setDocumentData={setDocumentData}
                      dataDocument={dataDocument}
                      setDataDocument={setDataDocument}
                      image={image}
                      setImage={setImage}
                      open={open}
                      setOpen={setOpen}
                      newDoc={newDoc}
                      setNewDoc={setNewDoc}
                      selectedFile={selectedFile}
                      setSelectedFile={setSelectedFile}
                      base64Image={base64Image}
                      setBase64Image={setBase64Image}
                      documentTypeList={documentTypeList}
                      setDocumentTypeList={setDocumentTypeList}
                      isGync={isGync}
                      pastData={pastData}
                      from={"gync"}
                      anc={ancWatch}
                    />
                  </div>
                  <div>
                    <OPDPathology
                      patientHistoryData={patientHistoryData}
                      setPatientHistoryData={setPatientHistoryData}
                      pathologyData={pathologyData}
                      setPathologyData={setPathologyData}
                      serviceData={serviceData}
                      setServiceData={setServiceData}
                      dataPathology={dataPathology}
                      setDataPathology={setDataPathology}
                      editData={editData}
                      patientVisitedDepartmentId={patientVisitedDepartmentId}
                      markFavoriteData={markFavoriteData}
                      pastData={pastData}
                    />
                  </div>
                  <div>
                    <OPDRadiology
                      patientHistoryData={patientHistoryData}
                      setPatientHistoryData={setPatientHistoryData}
                      radiologyData={radiologyData}
                      setRadiologyData={setRadiologyData}
                      dataRadiology={dataRadiology}
                      setDataRadiology={setDataRadiology}
                      serviceData={serviceData}
                      setServiceData={setServiceData}
                      patientVisitedDepartmentId={patientVisitedDepartmentId}
                      markFavoriteData={markFavoriteData}
                      pastData={pastData}
                    />
                  </div>
                  <div>
                    <OPDServices
                      dataServices={dataServices}
                      setDataServices={setDataServices}
                      location={location}
                      pathologyData={pathologyData}
                      radiologyData={radiologyData}
                      serviceData={serviceData}
                      setServiceData={setServiceData}
                      doctorId={userRole?.employeeId}
                      patientVisitedDepartmentId={patientVisitedDepartmentId}
                      markFavoriteData={markFavoriteData}
                      pastData={pastData}
                    />
                  </div>
                  <div>
                    <Instruction
                      instractionDataResult={instractionDataResult}
                      setInstractionDataResult={setInstractionDataResult}
                      instraction={instraction}
                      setInstraction={setInstraction}
                      dataInstruction={dataInstruction}
                      setDataInstruction={setDataInstruction}
                      doctorId={userRole?.employeeId}
                      patientVisitedDepartmentId={patientVisitedDepartmentId}
                      markFavoriteData={markFavoriteData}
                    />
                  </div>
                  <div>
                    <OPDAdvice
                      fields={fields}
                      adviceData={adviceData}
                      setAdviceData={setAdviceData}
                      setFields={setFields}
                      pastData={pastData}
                      from={"gync"}
                    />
                  </div>
                  <div>
                    <OPDRef
                      dataRef={dataRef}
                      setDataRef={setDataRef}
                      doctorCoption={doctorCoption}
                      setdoctorCoption={setdoctorCoption}
                      departmentCOption={departmentCOption}
                      setDepartmentCOption={setDepartmentCOption}
                      pastData={pastData}
                      from={"gync"}
                    />
                  </div>

                  <div className="col-span-2">
                    {fields.find(
                      (option) =>
                        option.name === "procedures" && option.checked,
                    ) ? (
                      <OPDSurgery
                        surgeryData={surgeryData}
                        setSurgeryData={setSurgeryData}
                        dataSurgery={dataSurgery}
                        setDataSurgery={setDataSurgery}
                        patientVisitedDepartmentId={patientVisitedDepartmentId}
                        pastData={null}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-span-2">
                    <OPDMedication
                      patientHistoryData={patientHistoryData}
                      setPatientHistoryData={setPatientHistoryData}
                      actions={actions}
                      setActions={setActions}
                      medicationData={medicationData}
                      setMedicationData={setMedicationData}
                      dataMedication={dataMedication}
                      setDataMedication={setDataMedication}
                      openMedicationModal={openMedicationModal}
                      setOpenMedicationModal={setOpenMedicationModal}
                      patientData={patientData}
                      pastData={pastData}
                    />
                  </div>
                  <div className="col-span-2">
                    <NextFollowUp
                      departmentOption={departmentOption}
                      doctorOption={doctorOption}
                      setDoctorOption={setDoctorOption}
                      setDepartmentOption={setDepartmentOption}
                      patientData={patientData}
                      pastData={null}
                      setIsNoFollowup={setIsNoFollowup}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <ANCModal
              doctorId={userRole?.employeeId}
              patientVisitedDepartmentId={patientVisitedDepartmentId}
              anc={ancWatch}
              markFavoriteData={markFavoriteData}
              userRole={userRole}
              patientData={patientData}
              pastData={pastData}
              editData={editData}
              patientDetails={patientData}
              patientInfoApi={patientDetails}
              bloodgroupValue={bloodgroupValue}
              setIsNoFollowup={setIsNoFollowup}
            />
          )}
        </form>
        <CommonBackDrop openBackdrop={openBackdrop} />
        <GynacVitalChart
          openViewVitals={openViewVitals}
          setOpenViewVital={setOpenViewVital}
          patientId={patientId}
        />
        <PatientHistoryModalNewAll
          openPatientHistory={openPatientHistory}
          setPatientHistory={setPatientHistory}
          patientDetails={patientDetails}
          location={location}
        />
        <ANCPatientInfo
          openPartnerModal={openPartnerModal}
          setOpenPartnerModal={setOpenPartnerModal}
        />
        {openInvestigationModal && (
          <PathologyReportModal
            openInvestigationModal={openInvestigationModal}
            setOpenInvestigationModal={setOpenInvestigationModal}
            pathHistoryData={pathHistoryData}
            patientInfo={patientData}
            LIMSType={LIMSType}
            setRadioHistoryData={setRadioHistoryData}
            radioHistoryData={radioHistoryData}
          />
        )}
        {/* <PrescriptionDental
          openPrint={openPrint}
          setOpen={setOpenPrint}
          visitId={visitId}
          prescriptions={editData?.prescriptions}
          employeeId={userRole.employeeId}
        /> */}
        <ANCWorkSheet
          openWorkSheet={openWorkSheet}
          setOpenANCWorkSheet={setOpenANCWorkSheet}
          patientData={patientData}
          parentId={parentId}
        />

        <ANCView
          openANcView={openANcView}
          setOpenANCView={setOpenANCView}
          patientData={patientData}
          bloodgroupValue={bloodgroupValue}
        />
        <Customs open={openGrowthChart} setOpen={setOpenGrowthChart} />
        <AdviceAdmissionModal
          open={openAdmissionAdvice}
          close={handleCloseAdmissionAdvice}
          handleAdmissionField={handleAdmissionField}
          setAdviceDetails={setAdviceDetails}
          editData={editData}
        />
        <ConfirmationModal
          confirmationOpen={openConfimationModal}
          confirmationHandleClose={handleClose}
          confirmationSubmitFunc={() => {
            handleForcefullyCloseFun();
          }}
          confirmationLabel="Confirmation "
          confirmationMsg="You Want Close Anc ?"
          confirmationButtonMsg="Yes"
        />
        {((location?.state?.status === "Confirmed" ||
          patientData?.admissionId > 0) &&
          userRole?.isDoctor === true) ||
        ((location?.state?.status === "Confirmed" ||
          patientData?.admissionId > 0) &&
          userRole?.role === "RMO") ? (
          <ConfirmationModal
            confirmationOpen={openPost}
            confirmationHandleClose={() => {
              setOpenPost(false);
            }}
            confirmationSubmitFunc={() => {
              SaveGynacEmr();
            }}
            confirmationLabel="Confirmation "
            confirmationMsg="Are you sure want to add record ?"
            confirmationButtonMsg="Add"
          />
        ) : (
          ""
        )}
        {openRequestModal && (
          <ReqInvestigationFormModal
            openReqInvmodal={openRequestModal}
            setopenInvModal={setOpenRequestModal}
            patientDetails={patientDetails}
            editData={editData}
            patientInfoApi={patientDetails}
            bloodgroupValue={bloodgroupValue}
          />
        )}
        {((location?.state?.status === "OnGoing" ||
          location?.state?.status === "Completed") &&
          userRole?.isDoctor === true) ||
        ((location?.state?.status === "OnGoing" ||
          location?.state?.status === "Completed") &&
          userRole?.role === "RMO") ? (
          <ConfirmationModal
            confirmationOpen={openPost}
            confirmationHandleClose={() => {
              setOpenPost(false);
            }}
            confirmationSubmitFunc={() => {
              SaveGynacEmr();
            }}
            confirmationSubmitFunc2={() => {
              saveEMRGeneralWithPrint();
            }}
            confirmationLabel="Confirmation "
            confirmationMsg="Are you sure want to add record ?"
            confirmationButtonMsg="Save"
            confirmationButtonMsg2="Save And Print"
          />
        ) : (
          ""
        )}
      </FormProvider>
    </div>
  );
};

export default GynacEmr;
